var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"code-container"},[_c('button',{staticClass:"copy-btn",attrs:{"title":_vm.$t('COMMON.COPY')},on:{"click":function($event){return _vm.$emit('copy_code', _vm.source)}}},[_c('i',{staticClass:"far fa-copy"})]),_c('code',{staticClass:"code-content"},[_vm._v(" "+_vm._s(_vm.source)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }